<template>
    <section class="bg-[#F2F2F2] lg:py-16 py-8 w-full">
      <div class="px-4 mx-auto max-w-5xl">
        <h2 class="mb-6 text-2xl text-center lg:mb-8 md:mb-8 xl:mb-16 font-ww-bold md:text-3xl xl:text-42">
          Frequently Asked Questions
        </h2>
  
        <div class="space-y-4">
          <div
            v-for="(item, index) in faqs"
            :key="index"
            class="bg-white rounded-lg shadow-sm"
          >
            <!-- бутон/заглавие -->
            <button
              class="flex justify-between items-center px-6 py-4 w-full text-left md:py-6 md:px-10"
              @click="toggle(index)"
            >
              <span class="text-base font-ww-bold xl:text-xl md:text-lg">
                {{ item.question }}
              </span>
              <span class="inline-flex flex-shrink-0 justify-center items-center ml-4">
                <svg v-if="isOpen(index)" width="18" height="3" viewBox="0 0 18 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 1.12305H17.9727" stroke="black" stroke-width="2.24658" stroke-miterlimit="10"/>
                </svg>
                <svg v-else width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 8.98633H17.9727" stroke="black" stroke-width="2.24658" stroke-miterlimit="10"/>
                  <path d="M8.98438 0V17.9727" stroke="black" stroke-width="2.24658" stroke-miterlimit="10"/>
                </svg>
              </span>
            </button>
  
            <transition 
              @enter="onEnter" 
              @after-enter="onAfterEnter" 
              @leave="onLeave"
              enter-active-class="transition-all duration-500 ease-out"
              leave-active-class="transition-all duration-500 ease-in"
            >
              <div
                v-show="isOpen(index)"
                class="px-6 pb-4 text-base text-gray-700 md:pb-8 md:px-10 xl:text-xl md:text-lg font-ww-regular"
                :style="index === 0 && openIndex.value === 0 ? { opacity: '1', height: 'auto', overflow: 'visible' } : {}"
              >
                {{ item.answer }}
              </div>
            </transition>
          </div>
        </div>
      </div>
    </section>
  </template>
  
  <script setup>
  import { ref } from "vue";
  
  const faqs = ref([
    {
      question: "Will six bags stay fresh?",
      answer:
        "A: Yes—our nitro-flush packaging keeps MindFlow peak-fresh for 12 months.",
    },
    {
      question: "I just bought—will this delay shipment?",
      answer:
        "No. Your upgrade is added to the same order and ships on the same schedule.",
    },
    {
      question: "What if I change my mind?",
      answer:
        "You're covered by the 30-day \"Get In Flow\" guarantee—hassle-free refunds.",
    },
  ]);
  
  // Currently open panel (single accordion)
  const openIndex = ref(0) // First item open by default
  
  const isOpen = (i) => openIndex.value === i
  const toggle = (i) => {
    if (openIndex.value === i) {
      openIndex.value = null
    } else {
      openIndex.value = i
    }
  }
  
  // Smooth height and opacity animation
  function onEnter (el) {
    // Skip animation if element already has inline styles (initial render)
    if (el.style.opacity === '1' && el.style.height === 'auto') {
      return
    }
    
    el.style.height = '0px'
    el.style.overflow = 'hidden'
    el.style.opacity = '0'
    el.style.transition = 'height 500ms cubic-bezier(0.25, 0.46, 0.45, 0.94), opacity 400ms cubic-bezier(0.25, 0.46, 0.45, 0.94)'
    
    // Force reflow, then animate to real height
    requestAnimationFrame(() => {
      el.style.height = el.scrollHeight + 'px'
      el.style.opacity = '1'
    })
  }
  
  function onAfterEnter (el) {
    el.style.height = 'auto'
    el.style.overflow = 'visible'
    el.style.opacity = '1'
  }
  
  function onLeave (el) {
    el.style.height = el.scrollHeight + 'px'
    el.style.overflow = 'hidden'
    el.style.opacity = '1'
    el.style.transition = 'height 500ms cubic-bezier(0.25, 0.46, 0.45, 0.94), opacity 300ms cubic-bezier(0.25, 0.46, 0.45, 0.94)'
    
    // After one frame, animate to 0 for closing animation
    requestAnimationFrame(() => {
      el.style.height = '0px'
      el.style.opacity = '0'
    })
  }
  </script>
  
  <style scoped>
  </style>
  